import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import loginModules from "@/store/loginModules"
import registerModules from './registerModules';
import buyCourseModules from "./buyCourseModules";
import courseModules from './courseModules';
import settingModules from './settingModules';
import userModules from './userModules';
import profileModules from './profileModules';
import coachModules from './coachModules';
import learnnerModules from './learnnerModules';
import authModules from './authModules';
import schoolModules from './schoolModules';
import createCourseModules from './createCourseModules';
import notificationModules from './notificationModules';
import categoryModules from './categoryModules';
import financialModules from './financialModules';
import scheduleModules from './scheduleModules';
import leaveModules from './leaveModules';
import orderModules from './orderModules';
import eventsModules from './eventsModules';
import consentModules from './consentModules';
import attendanceModules from './attendanceModules';
import dashboardModules from './dashboardModules';
import reserveModules from './reserveModules';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    authModules,
    loginModules,
    registerModules,
    categoryModules,
    courseModules,
    buyCourseModules,
    settingModules,
    profileModules,
    userModules,
    coachModules,
    learnnerModules,
    schoolModules,
    createCourseModules,
    notificationModules,
    financialModules,
    scheduleModules,
    leaveModules,
    orderModules,
    eventsModules,
    consentModules,
    attendanceModules,
    dashboardModules,
    reserveModules,
  },
  plugins: [createPersistedState({
    paths: ['buyCourseModules.cartCount', 'buyCourseModules.cartList']
  })],
})

export default store